























































import Vue from "vue";
import iwTabsLanguageSwitcher from "@/encoding/components/buildingBlocks/tabsLanguageSwitcher/TabsLanguageSwitcher.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({

    components: {
        iwTabsLanguageSwitcher: iwTabsLanguageSwitcher,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            inputName: "epc-description",
            specificId: uuidv4() as string
        };
    },
    computed: {
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"]("transaction.certificates.epc.description.en") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("transaction.certificates.epc.description.fr") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("transaction.certificates.epc.description.nl");
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "APARTMENT", "GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        languages: function(): Array<Record<string, unknown>> {
            return [
                {
                    "language": this.$t("english_language"),
                    "prefix": "en",
                    "validate": false,
                },
                {
                    "language": this.$t("french_language"),
                    "prefix": "fr",
                    "validate": false,
                },
                {
                    "language": this.$t("dutch_language"),
                    "prefix": "nl",
                    "validate": false
                }
            ];
        }
    }
});
